import type { SettingsDestination } from './SettingsRail';

/**
 * Every settings destination, in the order a seller is likely to want them.
 *
 * Storefront appears only when the shop has enabled it — the page exists either
 * way, but listing a destination that answers "this feature is not enabled" is
 * a dead end in the one place meant to be a map.
 */
export const settingsDestinations = (storefrontEnabled?: boolean | null): SettingsDestination[] => [
  { key: 'profile', label: 'Profile', href: '/settings/profile' },
  { key: 'company', label: 'Business', href: '/settings/company' },
  { key: 'payout', label: 'Payouts', href: '/settings/payout' },
  ...(storefrontEnabled
    ? [{ key: 'storefront', label: 'Storefront', href: '/settings/storefront' }]
    : []),
  // Both of these were links in the account menu that led to a 404.
  { key: 'selling-fees', label: 'Selling fees', href: '/settings/selling-fees' },
  { key: 'terms', label: 'Terms', href: '/settings/terms' },
];
